
import './js/navigation';
import './js/skip-link-focus-fix';

import './sass/style.scss';
import '../node_modules/aos/dist/aos.css';

import AOS from 'aos';

import 'lazysizes';
import Headroom from 'headroom.js';

import Swiper from 'swiper'
import '../node_modules/swiper/dist/css/swiper.min.css';
// import { connect } from 'tls';
AOS.init({
  once: true
});

function fixAdminBar() {
  const header = document.getElementById('masthead');
  const bar = document.getElementById('wpadminbar');
  const main = document.getElementById('content');
  if (bar) {
    var barHt = bar.getBoundingClientRect().height;
    if (header) {
      header.style.top = barHt + "px";
    }
  }
  if(window.innerWidth > 600) {
    if (main && bar) {
      main.style.marginTop = barHt + "px";
    }
  } else {
    if (main && bar) {
      main.style.removeProperty('marginTop');
    }
  }
}


window.addEventListener('load', function() {
  if (document.body.classList.contains('admin-bar')) {
    window.addEventListener('resize', fixAdminBar);
     fixAdminBar();
  }


  let swipe = document.querySelectorAll('[data-swiper-target]');
  swipe.forEach(element => {
    let swipeOffset = window.outerWidth/20 + 20;
    if (element.childElementCount < 3){swipeOffset = 0};
    var mySwiper = new Swiper(element, {
      speed: 400,
      slidesPerView: 'auto',
      spaceBetween: 20,
      slidesOffsetBefore: swipeOffset,
      slidesOffsetAfter: swipeOffset,
      threshold: 6,
      longSwipes: true,
      slidesPerGroup: 1,
      centerInsufficientSlides: true,
      grabCursor: true,
      breakpoints: {
        600: {
          slidesOffsetBefore: swipeOffset/2,
          slidesOffsetAfter: swipeOffset/2,
        }
      },
      on: {
        init: function() {
          var maxW = this.slidesGrid[this.slidesGrid.length - 1] + this.slidesSizesGrid[0];
          if (maxW * 1.2 <= window.outerWidth) {
            this.allowTouchMove = false
            // this.unsetGrabCursor()
          } else {
            this.allowTouchMove = true
            // this.setGrabCursor();
          }
        },
        resize: function() {
          var maxW = this.slidesGrid[this.slidesGrid.length - 1] + this.slidesSizesGrid[0];
          swipeOffset = window.outerWidth / 20 + 25;

          this.slidesOffsetBefore = swipeOffset;
          this.slidesOffsetAfter = swipeOffset;

          if (maxW * 1.2 <= window.outerWidth) {
            this.allowTouchMove = false
            // this.unsetGrabCursor()
          } else {
            this.allowTouchMove = true
            // this.setGrabCursor();
          }
        }
      }
    });
  });
})

let header = document.getElementById('masthead');
let content = document.getElementById('content');

function handleHeaderPadding() {
  if (header) {
    let headerHt = header.getBoundingClientRect().height;
    content.style.borderTopWidth = headerHt + 'px';
    header.classList.add('preFixed');
    var headerHeadroom = new Headroom(header, {tolerance: 5});
    headerHeadroom.init();
    if (document.getElementById('wpadminbar')) {
      if (window.innerWidth >= 600) {
        let wpHt = document.getElementById('wpadminbar').getBoundingClientRect().height;
        header.style.top = wpHt;
      }
    }
  }
}

window.addEventListener('load', handleHeaderPadding);
window.addEventListener('resize', handleHeaderPadding);

window.addEventListener('scroll', function() {
  if (window.scrollY > 120) {
    header.classList.add('fixedHeader');
  } else {
    header.classList.remove('fixedHeader')
  }
})

Array.from(document.querySelectorAll('[data-module]')).forEach(el => {
  const name = el.getAttribute('data-module');
  const Module = require(`./js/modules/${name}`).default
  new Module(el)
})